export const contactCenterHomepagePath = "/contact-center"
export const chatQueuesPath = `${contactCenterHomepagePath}/chat-queues`
